import { Icons } from './icons';

const scopes = [
  { icon: Icons.Gauge, label: 'Platform behavior' },
  { icon: Icons.Plane, label: 'Flight status' },
  { label: '🇦🇪  UAE' },
  { label: '🟢  WhatsApp' },
];

export function ScopeHeader() {
  return (
    <header className="scope-header">
      <div className="scope-pickers" aria-label="Configuration scope">
        {scopes.map(({ icon: Icon, label }) => (
          <button className="scope-button" key={label}>
            {Icon ? <Icon size={17} /> : null}
            <span>{label}</span>
            <Icons.ChevronDown size={15} />
          </button>
        ))}
      </div>
      <div className="header-actions">
        <button className="version-pill">
          <span className="status-dot" /> Draft v12 <Icons.ChevronDown size={14} />
        </button>
        <span className="blocked-pill">△ Publication blocked</span>
        <button className="icon-button" aria-label="Help">
          <Icons.Help size={20} />
        </button>
        <button className="icon-button" aria-label="Notifications">
          <Icons.Bell size={20} />
        </button>
      </div>
    </header>
  );
}
